<script setup lang="ts">
// Properties
import type Article from "~~/types/Article";
import FeaturedArticle from "~/components/articles/FeaturedArticle.vue";
import ArticleItemList from "~/components/articles/ArticleItemList.vue";
import ArticlePagination from "~/components/articles/ArticlePagination.vue";
import { useArticle } from "~/composables/article";
import SearchInputTag from "~/components/form/SearchInputTag.vue";

const { loading, page, searchText, result, fetchResult } = useArticle();
const route = useRoute();

const articles = computed(() => {
    return result.value?.data
        ? (result.value.data as Article[])
        : result.value?.hits
          ? (result.value.hits as Article[])
          : [];
});
const featuredArticle = computed(() => {
    if (page.value > 1 || route.query.searchArticle) return null;

    return articles.value.length > 0 ? articles.value[0] : null;
});

await fetchResult();
</script>

<template>
    <div class="relative">
        <div
            v-show="loading"
            class="fixed z-20 h-full w-full bg-white pt-60 text-center opacity-80"
        >
            <img
                src="/images/spinnersBlocksWave.svg"
                alt="Spinner"
                class="mx-auto w-20"
            />
            <span class="px-4 py-2">Loading...</span>
        </div>

        <div
            v-if="articles.length <= 0"
            class="py-28 text-center text-gray-400"
        >
            sorry, no articles are available at the moment...
        </div>
        <div v-else>
            <FeaturedArticle
                v-if="featuredArticle"
                :article="featuredArticle"
                class="mb-10"
            />

            <div
                class="relative container"
                :class="featuredArticle ? '' : 'pt-10'"
            >
                <div class="right-20 z-10 lg:absolute lg:w-60">
                    <SearchInputTag
                        v-model="searchText"
                        placeholder="Search Articles..."
                    />
                </div>
            </div>

            <!-- List result -->
            <div
                v-if="!featuredArticle || articles?.length > 1"
                class="relative container mb-10 lg:px-20"
            >
                <h2 class="my-10 text-center text-3xl font-bold">Recent Posts</h2>
                <template
                    v-for="(article, index) in articles"
                    :key="article.id"
                >
                    <ArticleItemList
                        v-if="!featuredArticle || index > 0"
                        :article="article"
                    />
                </template>

                <ArticlePagination
                    v-if="result"
                    :result="result"
                />
            </div>
            <div
                v-else
                class="mt-16 py-10 text-center text-gray-400"
            >
                More articles coming soon...
            </div>
        </div>
    </div>
</template>

<style scoped></style>
